import styled from "styled-components";
import { whiteBgOnClickAnim, scaleOnClickAnim } from "../../animations";

export const CardsContainer = styled.div`
  display: -webkit-box;
  justify-content: flex-start;
  position: relative;
`;

export const Results = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  opacity: ${(p) => (p.initAnimation ? "0" : "1")};
  animation: ${(p) => p.initAnimation && "init 0.5s ease-in forwards"};
  animation-delay: ${(p) => p.childCount * 0.5}s;
  width: 110px;
  p {
    text-transform: uppercase;
    font-size: 10px;
    text-align: center;
    color: #483b3b;
    width: 83px;
  }
  @keyframes init {
    0% {
      opacity: 0;
      transform: translate3d(0, -30px, 0);
    }
    100% {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }
`;

export const CardBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Text = styled.p`
  margin: 14px 0;
  font-size: 12px;
`;

export const Subtext = styled.span`
  margin: 5px;
  opacity: ${(p) => (p.initAnimation ? "0" : "1")};
  transform: ${(p) =>
    p.initAnimation ? "translateY(-36px)" : "translateY(-18px)"};
  animation: ${(p) => p.initAnimation && "init2 0.5s ease-in forwards"};
  animation-delay: ${(p) => p.childCount * 0.5 + 0.2}s;
  p {
    color: ${(p) =>
      p.isSame && p.isWin ? "#ffb000 !important" : "#483b3b !important"};
    font-size: 20px;
    width: 14px;
    margin: 0;
  }
  g {
    stroke: ${(p) => (p.isWin ? "#ffb000" : "#483b3b")};
  }
  @keyframes init2 {
    0% {
      opacity: 0;
      transform: translateY(-36px);
    }
    100% {
      opacity: 1;
      transform: translateY(-18px);
    }
  }
`;
export const BetInfoBox = styled.div`
  padding: 20px 12px 0 12px;
  margin: 24px auto;
  background: rgba(0, 0, 0, 0.1);
  margin-left: -12px;
  border-radius: 12px;
  width: 337px;
`;

export const TitleS = styled.div`
  font-size: 20px;
  font-weight: bold;
`;

export const SubTitle = styled.div`
  font-size: 20px;
  font-family: "GT America, regular";
  line-height: 1.4;
  padding-bottom: 24px;
  word-break: break-all;
  user-select: text;
`;

export const Button = styled.div`
  background: #ffb000;
  border: solid 3px #ffb000;
  border-radius: 38px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: #ff3920;
  text-transform: uppercase;
  font-size: 20px;
  position: relative;
  cursor: pointer;
  :after {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    transform: scale(1);
    background: #ffffff;
    border: solid 3px #ffffff;
    border-radius: 38px;
    right: 50%;
    bottom: 50%;
    transform: translate(50%, 50%);
    width: 100%;
    height: 100%;
    opacity: 0;
    animation: ${(p) => p.btnAnimation && whiteBgOnClickAnim};
    animation-duration: 0.5s;
  }
  animation: ${(p) => p.btnAnimation && scaleOnClickAnim};
  animation-duration: 0.5s;
  pointer-events: ${(p) => (p.soundPlayed ? "none" : "auto")};
`;
export const Scroll = styled.input`
  background: rgba(0, 0, 0, 0.3);
  height: 6px;
  border-radius: 3px;
  & {
    -webkit-appearance: none;
    width: 100%;
    margin: 11.5px 0;
  }
  &:focus {
    outline: none;
  }
  &::-webkit-slider-runnable-track {
    width: 100%;
    height: 6px;
    cursor: pointer;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
    background: none;
    border-radius: 1px;
    border: 0px solid rgba(0, 0, 0, 0.95);
  }
  &::-webkit-slider-thumb {
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
    border: 0px solid #000000;
    height: 100%;
    min-width: 50px;
    width: ${(p) => p.w + "%"};
    border-radius: 3px;
    background: #ffb000;
    cursor: pointer;
    -webkit-appearance: none;
  }
  &::-moz-slider-thumb {
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
    border: 0px solid #000000;
    height: 100%;
    min-width: 50px;
    width: ${(p) => p.w + "%"};
    border-radius: 3px;
    background: #ffb000;
    cursor: pointer;
    -webkit-appearance: none;
  }
  &:focus::-webkit-slider-runnable-track {
    /* background: #000000;
    opacity: 0.3; */
  }
  &::-moz-range-track {
    width: 100%;
    height: 6px;
    cursor: pointer;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
    /* background: #000000; */
    opacity: 0.3;
    border-radius: 3px;
    border: 0px solid rgba(0, 0, 0, 0.95);
  }
  &::-moz-range-thumb {
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
    border: 0px solid #000000;
    height: 100%;
    /* width: 50px; */
    width: ${(p) => p.w + "%"};

    border-radius: 3px;
    background: #ffb000;
    cursor: pointer;
  }
  &::-ms-track {
    width: 100%;
    height: 6px;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    color: transparent;
  }
  &::-ms-fill-lower {
    background: #faac00;
    border: 0px solid rgba(0, 0, 0, 0.95);
    border-radius: 2px;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
  }
  &::-ms-fill-upper {
    background: #ffb000;
    border: 0px solid rgba(0, 0, 0, 0.95);
    border-radius: 2px;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
  }
  &::-ms-thumb {
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
    border: 0px solid #000000;
    height: 100%;
    /* width: 50px; */
    width: ${(p) => p.w + "%"};

    border-radius: 13px;
    background: #ffb000;
    cursor: pointer;
    height: 3px;
  }
  &:focus::-ms-fill-lower {
    background: #ffb000;
  }
  &:focus::-ms-fill-upper {
    background: #ffb205;
  }
`;

export const ScrollBar = styled.div`
  background: rgba(0, 0, 0, 0.3);
  height: 6px;
  border-radius: 3px;
  width: 100%;
  border-radius: 7px;
  bottom: 0px;
  background-color: rgba(0, 0, 0, 0.35);
  position: relative;
  div {
    background: #ffb000;
    border-radius: 3px;
    position: absolute;
    top: 0;
  }
`;

export const Loader = styled.div`
  width: 100%;
  height: calc(100% - 126px);
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    font-size: 30px;
    color: #ffb000;
    display: flex;
    justify-content: center;
    align-items: baseline;
    text-transform: uppercase;
  }
  span {
    width: 7px;
    height: 7px;
    background: #ffb000;
    border-radius: 50%;
    margin: 0 5px;
    animation: loading 1.5s infinite;
    :nth-child(1) {
      animation-delay: 0s;
    }
    :nth-child(2) {
      animation-delay: 0.25s;
    }
    :nth-child(3) {
      animation-delay: 0.5s;
    }
  }
  @keyframes loading {
    0% {
      transform: scale(1);
      animation-timing-function: cubic-bezier(0.33, 0, 0, 1);
    }
    50% {
      transform: scale(0.1);
      animation-timing-function: cubic-bezier(0.33, 0, 0, 1);
    }
    100% {
      transform: scale(1);
    }
  }
`;
